import React from 'react';
import { formatCurrencyStyled } from '../../visuals/currency.formatted';
import { ConceptoTotales, totalEnLetra } from '../components/preview.totales.model';

interface PreviewTotalesProps {
    totales: ConceptoTotales;
    /** Totales deciding which tax rows are visible, when they differ from the ones displayed */
    gateTotales?: ConceptoTotales;
    letraPrefix?: string;
    showDescuento?: boolean;
}

function PreviewTotales({ totales, gateTotales, letraPrefix, showDescuento }: PreviewTotalesProps) {
    const gate = gateTotales || totales;
    return (
        <div className="totalWrap">
            <div className="_letra">
                <p>
                    {letraPrefix ? <b>{letraPrefix}</b> : null}
                    {totalEnLetra(totales.total)}
                </p>
            </div>
            <div className="_totales">
                <div>
                    <p className="_subtotal">{formatCurrencyStyled(totales.subtotal)}</p>
                    <p className="_subtotal">Subtotal</p>
                </div>
                {
                    showDescuento && gate.descuento ?
                        <div>
                            <p className="_subtotal red">{formatCurrencyStyled(-totales.descuento)}</p>
                            <p className="_subtotal red">Descuento</p>
                        </div>
                        : ''
                }
                {
                    gate.ieps_retenido ?
                        <div className="_tax">
                            <p className="_tax">{formatCurrencyStyled(totales.ieps_retenido)}</p>
                            <p className="_tax">IEPS Retenido</p>
                        </div>
                        : ''
                }
                {
                    gate.ieps_trasladado ?
                        <div className="_tax">
                            <p className="_tax">{formatCurrencyStyled(totales.ieps_trasladado)}</p>
                            <p className="_tax">IEPS Trasladado</p>
                        </div>
                        : ''
                }
                {
                    gate.iva_retenido ?
                        <div className="_tax">
                            <p className="_tax">{formatCurrencyStyled(totales.iva_retenido)}</p>
                            <p className="_tax">IVA Retenido</p>
                        </div>
                        : ''
                }
                {
                    gate.iva_trasladado ?
                        <div className="_tax">
                            <p className="_tax">{formatCurrencyStyled(totales.iva_trasladado)}</p>
                            <p className="_tax">IVA Trasladado</p>
                        </div>
                        : ''
                }
                {
                    gate.isr ?
                        <div className="_tax">
                            <p className="_tax">{formatCurrencyStyled(totales.isr)}</p>
                            <p className="_tax">ISR Retenido</p>
                        </div>
                        : ''
                }
                <div>
                    <p className="_total">
                        <b>{formatCurrencyStyled(totales.total)}</b>
                    </p>
                    <p className="_total">
                        <b>Total</b>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default PreviewTotales;
